import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function ConditionsGenerales() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      {/* Hero */}
      <section className="pt-40 pb-16 bg-[#0A2540]">
        <div className="max-w-7xl mx-auto px-6 md:px-10 text-center">
          <span className="inline-block px-4 py-1.5 rounded-full border border-white/20 text-white/60 text-xs uppercase tracking-widest mb-6">
            Légal
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Conditions générales</h1>
          <p className="text-white/50 text-sm">Dernière mise à jour : {new Date().toLocaleDateString("fr-FR")}</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 bg-white flex-1">
        <div className="max-w-3xl mx-auto px-6 md:px-10">
          <div className="flex flex-col gap-10 text-gray-600 text-base leading-relaxed">

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">1. Présentation de l&apos;entreprise</h2>
              <p>
                Les présentes conditions générales régissent l&apos;utilisation du site internet de BOBROWSKA.
              </p>
              <ul className="mt-4 flex flex-col gap-2 text-sm">
                <li><strong>Entreprise :</strong> BOBROWSKA</li>
                <li><strong>Dirigeante :</strong> Ewa Bobrowska</li>
                <li><strong>Statut :</strong> Entrepreneur individuel</li>
                <li><strong>SIRET :</strong> 100 085 687 00018</li>
                <li><strong>Adresse :</strong> 49 Rue, 67130 Wisches, France</li>
                <li><strong>Email :</strong> ewabobroowska@outlook.com</li>
                <li><strong>Téléphone :</strong> +33 6 05 61 30 58</li>
                <li><strong>Activité :</strong> 70.22Z — Conseil pour les affaires et autres conseils de gestion</li>
              </ul>
            </div>

            <div className="w-full h-px bg-gray-100"></div>

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">2. Objet du site</h2>
              <p>
                Le présent site internet a pour objet de présenter les services de conseil en gestion et développement d&apos;entreprise proposés par BOBROWSKA. Les informations publiées sur ce site sont fournies à titre informatif et ne constituent pas un engagement contractuel.
              </p>
            </div>

            <div className="w-full h-px bg-gray-100"></div>

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">3. Propriété intellectuelle</h2>
              <p>
                L&apos;ensemble des contenus présents sur ce site (textes, images, logos, graphismes) sont protégés par le droit de la propriété intellectuelle et sont la propriété exclusive de BOBROWSKA. Toute reproduction, représentation, modification ou exploitation, totale ou partielle, de ces contenus est interdite sans autorisation préalable écrite.
              </p>
            </div>

            <div className="w-full h-px bg-gray-100"></div>

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">4. Responsabilité</h2>
              <p>
                BOBROWSKA s&apos;efforce de maintenir les informations publiées sur ce site à jour et exactes. Toutefois, BOBROWSKA ne saurait être tenue responsable des erreurs, omissions ou résultats qui pourraient être obtenus par un mauvais usage de ces informations.
              </p>
            </div>

            <div className="w-full h-px bg-gray-100"></div>

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">5. Droit applicable</h2>
              <p>
                Les présentes conditions générales sont soumises au droit français. En cas de litige, les tribunaux français seront seuls compétents.
              </p>
            </div>

            <div className="w-full h-px bg-gray-100"></div>

            <div>
              <h2 className="text-xl font-bold text-[#0A2540] mb-4">6. Contact</h2>
              <p>
                Pour toute question relative aux présentes conditions générales, vous pouvez nous contacter à l&apos;adresse suivante : <a href="mailto:ewabobroowska@outlook.com" className="text-[#0A2540] underline">ewabobroowska@outlook.com</a>
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
